import React from "react";
import "./EmojiRadioInput.css";
import SelectInput from "../SelectInput/SelectInput";

const EmojiRadioInput = (props) => {
  return (
    <div className="emoji-radio-input">
      {props.data
        ? props.data.map((d) => (
            <div className="emoji-radio-option" key={props.name + "_" + d.id}>
              {d.hasOptions ? (
                <label
                  htmlFor={props.name + "_" + d.id}
                  className={
                    props.incomingValue === d.value
                      ? "emoji-label emoji-label-checked"
                      : "emoji-label"
                  }
                >
                  <div className="emoji-label-inner">
                    {d.hasImage ? (
                      <img
                        src={d.image}
                        alt={d.alt}
                        className="emoji-radio-input-icon"
                      />
                    ) : (
                      <span>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </span>
                    )}
                    <input
                      type="radio"
                      name={props.name}
                      id={props.name + "_" + d.id}
                      value={d.backendValue}
                      onChange={(e) => props.onChange(e, d.value)}
                      checked={props.incomingValue === d.value ? true : false}
                      onClick={(e) => e.stopPropagation()}
                    />
                    <span>{d.longValue}</span>
                  </div>
                  <div>
                    {props.incomingValue === d.value ? (
                      <SelectInput
                        name="cities"
                        data={d.data}
                        placeholder="Choose city..."
                        inputValue={props.inputValue}
                        handleOnChangeValue={props.handleonChangeValue}
                        zIndexValue={props.zIndexValue}
                      />
                    ) : null}
                  </div>
                </label>
              ) : (
                <label
                  htmlFor={props.name + "_" + d.id}
                  className={
                    props.incomingValue === d.value
                      ? "emoji-label emoji-label-checked"
                      : "emoji-label"
                  }
                >
                  <div className="emoji-label-inner">
                    {d.hasImage ? (
                      <img
                        src={d.image}
                        alt={d.alt}
                        className="emoji-radio-input-icon"
                      />
                    ) : (
                      <span>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                      </span>
                    )}
                    <input
                      type="radio"
                      name={props.name}
                      id={props.name + "_" + d.id}
                      value={d.backendValue}
                      onChange={(e) => props.onChange(e, d.value)}
                      checked={props.incomingValue === d.value ? true : false}
                    />
                    <span>{d.longValue}</span>
                  </div>
                </label>
              )}
            </div>
          ))
        : null}
    </div>
  );
};

export default EmojiRadioInput;
